import React from 'react'
import {Button} from '@material-ui/core'
// import {Link} from 'react-router-dom'
// import {Carousel} from 'react-responsive-carousel'
import {useHistory} from 'react-router-dom'
import portrait from '../Portrait.jpg'
import slide from '../Slider7.jpg'
import "../styles/Home.css"


function Home() {
    const history = useHistory();
    return (
        <div>
            <div style={{padding:'60px 0 0 0', textAlign:'center', width:'100vw'}}>
                <img className="imgHead" src={slide} alt="main"/>
                <img className="imgMobHead" src={portrait} alt="mobMain"/>
            </div>
            <div className="btnCon">
                <Button variant="contained" color="primary" onClick={() => history.push('/membership')}>Become a Member</Button>
                <Button variant="contained" color="primary" style={{marginLeft:"40px"}}onClick={() => history.push('/membership_login')}>Member Login</Button>
                {/* <Button variant="contained" color="primary" onClick={() => history.push('/login')}>Login</Button> */}
            </div>
        </div>
    )
}

export default Home
